"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaybackFormula = void 0;
exports.getPayback = getPayback;
const general_formulas_1 = require("./general-formulas");
/*
 * Enumeration of Payback formala implementation names
 */
var PaybackFormula;
(function (PaybackFormula) {
    PaybackFormula[PaybackFormula["DEFAULT"] = 0] = "DEFAULT";
})(PaybackFormula || (exports.PaybackFormula = PaybackFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getPayback(formula) {
    switch (formula) {
        default:
            return default_payback;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_payback = (drawAmount, totalInterest) => {
    // ensure valid argument types
    if (typeof drawAmount === 'number' && typeof totalInterest === 'number') {
        return (0, general_formulas_1.toFixedNumber)(drawAmount + totalInterest, 2);
    }
    return NaN;
};
//# sourceMappingURL=payback-formula.js.map